import { render, staticRenderFns } from "./ReviewDetails.vue?vue&type=template&id=b039234a&scoped=true"
import script from "./ReviewDetails.vue?vue&type=script&lang=js"
export * from "./ReviewDetails.vue?vue&type=script&lang=js"
import style0 from "./ReviewDetails.vue?vue&type=style&index=0&id=b039234a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b039234a",
  null
  
)

export default component.exports